import { Component, OnDestroy, OnInit } from '@angular/core';
import { SwqModalStatusModel } from '../../models/swq-model-status.model';
import { ActivatedRoute, Router } from '@angular/router';
import { LookUpResourceModel } from '../../models/lookup-resource.model';
import { SectionWiseService } from '../../service/section-wise.service';
import { GtmDatalayerUiService } from '../../../shared/service/ui/gtm-datalayer-ui.service';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sw-wrapper',
  templateUrl: './sw-wrapper.component.html'
})
export class SwWrapperComponent implements OnInit, OnDestroy {
  public swqModalStatusModel: SwqModalStatusModel = { swqModalIsOpen: false, question: new LookUpResourceModel() };
  public isDiscardModalOpen = false;
  private modalDiscardSubscription: Subscription;
  private modalSubscription: Subscription;

  constructor(
    private sectionWiseService: SectionWiseService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private gtmDataLayerUiService: GtmDatalayerUiService,
    private startUpUiService: StartUpConfigUiService
  ) {}

  ngOnInit() {
    this.gtmDataLayerUiService.initGtmDatalayer(this.startUpUiService.sessionInfo$, true).subscribe();

    this.modalSubscription = this.sectionWiseService.swqModalStatus$.subscribe({
      next: (res: SwqModalStatusModel) => {
        this.swqModalStatusModel = res;
        if (this.swqModalStatusModel.swqModalIsOpen) {
          this.router.navigate(['./', this.swqModalStatusModel.question.QuestionNumber], {
            queryParams: { question: JSON.stringify(this.swqModalStatusModel.question) },
            relativeTo: this.activatedRoute,
            skipLocationChange: true
          });
        }
      }
    });
    this.modalDiscardSubscription = this.sectionWiseService.discardModalState$.subscribe((isOpen: boolean) => {
      this.isDiscardModalOpen = isOpen;
    });
  }

  ngOnDestroy(): void {
    this.modalDiscardSubscription.unsubscribe();
    this.modalSubscription.unsubscribe();
  }
}
